<template>
  <div></div>
</template>

<script>
import { isSafeRedirect } from '@/lib/safeRedirect'

export default {
  name: 'Logout',

  async created() {
    await this.$store.dispatch('logout')

    this.$track('session.Close', this.$store, { process: 'logOut' })

    this.$resetTracking()

    window.localStorage.clear()

    const redirect = this.$route.query?.redirect
    const target = isSafeRedirect(redirect)
      ? `/access?redirect=${encodeURIComponent(redirect)}`
      : '/access'

    location.replace(target)
  },
}
</script>
